import React from 'react'
import styled from 'styled-components/macro'

import margin from '../../styles/margin'
import Button from '../Button/Button'
import { Popup, PopupText } from './Popup'
import generalInput from './Input'

const Wrapper = styled.div`
  ${margin};
  position: relative;
  width: 100%;
  min-width: ${(props) => (props.noMinWidth ? '0' : '320px')};
`

const InnerWrapper = styled.div`
  display: flex;
`

const Input = styled.input`
  ${generalInput};

  width: 100%;
`

const RegularInput = ({
  placeholder,
  question,
  onQuestionAnswered,
  noButton,
  value,
  setValue,
  error,
  setError,
  ...styles
}) => {
  const handleChange = (e) => {
    setError(false)
    setValue(e.target.value)
  }

  const handleSubmit = () => {
    if (value.length >= 1) {
      if (value.length <= 60) {
        onQuestionAnswered({ [question.apiName]: value })
      } else {
        return setError('60 characters max')
      }
    } else {
      return setError('Please provide your role')
    }
  }

  const handleKeyDown = (e) => {
    // nobutton checks if we are submitting anything
    if (!noButton && e.key === 'Enter') {
      handleSubmit()
    }
  }

  const touched = value !== ''

  return (
    <Wrapper {...styles}>
      {error && (
        <Popup>
          <PopupText>{error}</PopupText>
        </Popup>
      )}
      <InnerWrapper>
        <Input
          error={error ? 1 : 0}
          type='text'
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        {!noButton && touched && (
          <Button error={error ? 1 : 0} title='Submit' onClick={handleSubmit} />
        )}
      </InnerWrapper>
    </Wrapper>
  )
}

export default RegularInput
